// const addSorting = (filter) => {
//   filter.sort.unshift({
//     field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
//     order: "desc",
//   });
// };
const addSortingbestsellers = (filter) => {
  let isJson = false,
    isSortJson = false;

  // Parse filter if it's a string
  if (typeof filter === "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }

  // Parse sort if it's a string
  if (typeof filter.sort === "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }

  // Only modify if the first field is "relevance"
  if (filter.sort?.[0]?.field === "relevance") {
    const newSort = [];

    newSort.push(filter.sort[0]); // keep relevance at the top

    const bestSellerField = "product_wizzy-best-selling_sortOrder:float";
    const alreadyExists = filter.sort.some((x) => x.field === bestSellerField);
    if (!alreadyExists) {
      newSort.push({
        field: bestSellerField,
        order: "asc",
      });
    }

    for (let i = 1; i < filter.sort.length; i++) {
      if (filter.sort[i].field !== bestSellerField) {
        newSort.push(filter.sort[i]);
      }
    }

    filter.sort = newSort;
  }

  if (isSortJson) filter.sort = JSON.stringify(filter.sort);
  if (isJson) filter = JSON.stringify(filter);

  return filter;
};


if (window.innerWidth > 768) {
    const mobileSearchInput = document.querySelector(
        'input[data-js-focus-overlay="search-results-overlay-mobile"]'
    );

    if (mobileSearchInput) {
        mobileSearchInput.remove();
    }
}


function syncAutocompleteWidth() {
  if(window.innerWidth > 768){
    const searchBar = document.querySelector(".wizzy-search-input");
    const autoComplete = document.querySelector(".wizzy-autocomplete-wrapper");

    if (!searchBar || !autoComplete) {
        return;
    }

    const width = searchBar.offsetWidth + 20;
    autoComplete.style.width = `${width}px`;
  }
}


window.addEventListener("load", syncAutocompleteWidth);

document.body.addEventListener("click", function (event) {
    if (event.target.matches(".wizzy-search-input")) {
        console.log("inside click of wizzy-search-input");
        setTimeout(syncAutocompleteWidth, 2);
    }
});

function getProductAttributeValue(product, attrId) {
  const attr = product.attributes.find((a) => a.id === attrId);
  return attr?.values?.[0]?.value?.[0]?.trim() ?? "";
}

function parsePriceNumber(value) {
  if (value == null) return 0;
  if (typeof value === "number") return value;
  return parseFloat(String(value).replace(/[^\d.]/g, "")) || 0;
}

function calcDiscountedPrice(sellingPrice, percentage) {
  const priceCents = Math.round(parsePriceNumber(sellingPrice) * 100);
  const discountCents = Math.floor((priceCents * percentage) / 100);
  return (priceCents - discountCents) / 100;
}

function finalizeOfferDisplayFields(product) {
  const selling = parsePriceNumber(product.sellingPrice);
  const compare = parsePriceNumber(product.price);
  const hasCompare =
    !!product.discountPercentage && compare > selling;

  product.hasComparePrice = hasCompare;
  product.displayPayPrice =
    product.discountedPriceAfterCoupen ||
    (selling ? selling.toFixed(2) : product.sellingPrice);
  product.hasOfferChip =
    product.offerMode === "save" ||
    product.offerMode === "bogo" ||
    product.offerMode === "trial";

  const pay = parsePriceNumber(product.displayPayPrice);
  let saveAmt = 0;

  if (product.offerMode === "bogo") {
    saveAmt = selling;
  } else if (product.offerMode === "save") {
    const saveBase = hasCompare ? compare : selling;
    saveAmt = saveBase - pay;
  } else if (product.offerMode === "trial" && hasCompare) {
    saveAmt = compare - selling;
  }

  if (saveAmt > 0.009) {
    product.saveAmount = saveAmt.toFixed(2);
    product.hasSaveAmount = true;
  } else {
    product.saveAmount = "";
    product.hasSaveAmount = false;
  }

  const pct = Number(product.savePercentageValue);
  const code = (product.couponCode || "").toUpperCase();
  const codePct = parseInt(code.replace(/SAVE/gi, ""), 10);
  const effectivePct = !isNaN(codePct) ? codePct : pct;

  if (product.offerMode === "bogo") {
    product.offerChipTone = "red";
  } else if (product.offerMode === "trial") {
    product.offerChipTone = "purple";
  } else if (effectivePct >= 70) {
    product.offerChipTone = "purple";
  } else if (effectivePct >= 60) {
    product.offerChipTone = "green";
  } else if (effectivePct >= 50) {
    product.offerChipTone = "blue";
  } else {
    product.offerChipTone = "red";
  }
}

function applyProductDiscount(product) {
  const catId = getProductAttributeValue(product, "product_cat_id_custom");
  const label1 = getProductAttributeValue(product, "product_custom_label_1_custom");
  const label1Upper = label1.toUpperCase();
  const defaultCouponPct = Number(window.wizzyThemeSettings?.couponAmount) || 5;

  product.offerMode = "plain";
  product.hasSaveLable = false;
  product.hasSaveLableForFive = false;
  product.buyOneGetOne = false;
  product.isTrial = false;
  product.isFreeshipOnly = false;
  product.discountApplicable = false;
  product.couponCode = "";
  product.discountedPriceAfterCoupen = "";
  product.hasOfferChip = false;
  product.hasSaveAmount = false;
  product.saveAmount = "";
  product.offerChipTone = "";

  if (catId.includes("M") || label1Upper.includes("FREESHIP")) {
    product.offerMode = "freeship";
    product.isFreeshipOnly = true;
    product.showFreeShippingtag = true;
    finalizeOfferDisplayFields(product);
    return;
  }

  if (label1Upper.includes("BOGO")) {
    product.offerMode = "bogo";
    product.buyOneGetOne = true;
    product.couponCode = "BOGO";
    product.hasOfferChip = true;
    finalizeOfferDisplayFields(product);
    return;
  }

  if (label1Upper.includes("TRIAL")) {
    product.offerMode = "trial";
    product.isTrial = true;
    product.hasOfferChip = true;
    finalizeOfferDisplayFields(product);
    return;
  }

  if (label1 && label1Upper.includes("SAVE")) {
    const percentage = parseInt(label1Upper.replace(/SAVE/gi, ""), 10);
    if (!isNaN(percentage) && percentage > 0) {
      product.offerMode = "save";
      product.discountApplicable = true;
      product.hasSaveLable = true;
      product.savePercentageValue = percentage;
      product.couponCode = label1.trim();
      product.discountedPriceAfterCoupen = calcDiscountedPrice(
        product.sellingPrice,
        percentage
      ).toFixed(2);
      product.hasOfferChip = true;
    }
    finalizeOfferDisplayFields(product);
    return;
  }

  if (!label1) {
    const discounted = calcDiscountedPrice(product.sellingPrice, defaultCouponPct);
    if (discounted > 0) {
      product.offerMode = "save";
      product.discountApplicable = true;
      product.hasSaveLableForFive = true;
      product.savePercentageValue = defaultCouponPct;
      product.couponCode = `SAVE${defaultCouponPct}`;
      product.discountedPriceAfterCoupen = discounted.toFixed(2);
      product.hasOfferChip = true;
    }
  }

  finalizeOfferDisplayFields(product);
}

const AUTOCOMPLETE_SUGGESTION_LIMIT = 6;

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function getAutocompleteAttrValues(product, attrId) {
  const attr = (product.attributes || []).find((item) => item.id === attrId);
  if (!attr || !Array.isArray(attr.values)) return [];

  const values = [];
  attr.values.forEach((entry) => {
    (entry.value || []).forEach((val) => {
      if (val) values.push(String(val).trim());
    });
  });
  return values;
}

function uniqueSuggestionValues(values) {
  const seen = new Set();
  const unique = [];
  values.forEach((raw) => {
    const value = String(raw || "").trim();
    if (!value) return;
    const key = value.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    unique.push(value);
  });
  return unique;
}

function highlightSuggestionLabel(value, query) {
  const safe = escapeHtml(value);
  const q = String(query || "").trim();
  if (!q) return safe;
  return safe.replace(
    new RegExp("(" + escapeRegExp(q) + ")", "ig"),
    "<em>$1</em>"
  );
}

function collectAutocompleteBrandAndTypeValues(data) {
  const payload = data && data.payload;
  if (!payload) return { brands: [], productTypes: [], query: "" };

  const products =
    (payload.products && payload.products.result) ||
    (Array.isArray(payload.products) ? payload.products : []);

  const brandValues = [];
  const typeValues = [];

  products.forEach((product) => {
    if (product.brand) brandValues.push(product.brand);

    const productTypes = getAutocompleteAttrValues(
      product,
      "product_product_type"
    );
    const customTypes = getAutocompleteAttrValues(
      product,
      "product_custom_product_type"
    );
    (productTypes.length ? productTypes : customTypes).forEach((type) => {
      typeValues.push(type);
    });
  });

  return {
    brands: uniqueSuggestionValues(brandValues).slice(
      0,
      AUTOCOMPLETE_SUGGESTION_LIMIT
    ),
    productTypes: uniqueSuggestionValues(typeValues).slice(
      0,
      AUTOCOMPLETE_SUGGESTION_LIMIT
    ),
    query: data.query || "",
  };
}

function buildExtraSuggestionSectionHtml(title, group, values, query, startIndex) {
  if (!values.length) return { html: "", nextIndex: startIndex, filters: [] };

  let html = `<li class="autocomplete-item-head autocomplete-item-head--${group}" data-wizzy-extra-section="true" data-group="${group}">${escapeHtml(title)}</li>`;
  const filters = [];
  let index = startIndex;

  values.forEach((value) => {
    const searchTerm = value.toLowerCase();
    const label = highlightSuggestionLabel(value, query);
    html += `
      <li class="autocomplete-item autocomplete-item--${group}" data-wizzy-extra-section="true" data-group="${group}">
        <a data-selectable="true" data-searchterm="${escapeHtml(searchTerm)}" href="#" class="autocomplete-link" data-index="${index}">
          <span class="wizzy-autocomplete-label">${label}</span>
          <span class="autocomplete-text-wrapper"></span>
        </a>
      </li>`;
    filters.push({
      group: group === "productTypes" ? "others" : "brands",
      value,
      filters: {},
      data: {},
      recentHistoryIndex: -1,
    });
    index += 1;
  });

  return { html, nextIndex: index, filters };
}

function appendAutocompleteBrandAndTypeSuggestions() {
  const extra = window.__wizzyAcExtraSuggestions;
  if (!extra) return;

  const suggestionsRoot = document.querySelector(
    ".wizzy-autocomplete-wrapper .wizzy-autocomplete-suggestions"
  );
  if (!suggestionsRoot) return;

  suggestionsRoot
    .querySelectorAll("[data-wizzy-extra-section]")
    .forEach((el) => el.remove());

  if (!extra.brands.length && !extra.productTypes.length) return;

  let list = suggestionsRoot.querySelector("ul.autocomplete-suggestions-list");
  if (!list) {
    const noResults = suggestionsRoot.querySelector(".autocomplete-no-results");
    if (noResults) noResults.remove();
    list = document.createElement("ul");
    list.className = "autocomplete-suggestions-list";
    suggestionsRoot.appendChild(list);
  }

  if (!window.wizzyConfig.pageStore) window.wizzyConfig.pageStore = {};
  if (!Array.isArray(window.wizzyConfig.pageStore.suggestionFilters)) {
    window.wizzyConfig.pageStore.suggestionFilters = [];
  }

  const suggestionFilters = window.wizzyConfig.pageStore.suggestionFilters;
  let nextIndex = suggestionFilters.length;
  let appendHtml = "";

  const typeSection = buildExtraSuggestionSectionHtml(
    "Product Type",
    "productTypes",
    extra.productTypes,
    extra.query,
    nextIndex
  );
  appendHtml += typeSection.html;
  suggestionFilters.push(...typeSection.filters);
  nextIndex = typeSection.nextIndex;

  const brandSection = buildExtraSuggestionSectionHtml(
    "Brands",
    "brands",
    extra.brands,
    extra.query,
    nextIndex
  );
  appendHtml += brandSection.html;
  suggestionFilters.push(...brandSection.filters);

  if (appendHtml) list.insertAdjacentHTML("beforeend", appendHtml);
}

const refreshTriggers = ["/pages/search", "herbspro.com/"];

function checkAndRefresh() {
  setTimeout(() => {
    const newURL = window.location.href;

    if (refreshTriggers.some((trigger) => newURL.includes(trigger))) {
      location.reload();
    }
  }, 100);
}

// Detect Back/Forward button press
window.addEventListener("popstate", checkAndRefresh);

const addSorting = (filter) => {
  let isJson = false,
    isSortJson = false;
  typeof filter == "string" && ((isJson = true), (filter = JSON.parse(filter))),
    typeof filter.sort == "string" &&
      ((isSortJson = true), (filter.sort = JSON.parse(filter.sort)));
  let newSort = [];
  filter.sort[0].field === "relevance"
    ? (newSort.push({
        field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
        order: "desc",
      }),
      filter.sort.forEach((x) => {
        x.field !=
          "product_value_tags_wizzy_hero_product_ruled_based_bt:float" &&
          newSort.push(x);
      }))
    : (newSort = filter.sort),
    (filter.sort = newSort),
    isSortJson && (filter.sort = JSON.stringify(filter.sort)),
    isJson && (filter = JSON.stringify(filter));
};
const addSortingforauto = (filter) => {
  let newSort = [];

  // First, push relevance
  newSort.push({
    field: "relevance",
    order: "desc", // assuming you want descending relevance; change if needed
  });

  // Then, push best-selling
  newSort.push({
    field: "product_wizzy-best-selling_sortOrder:float",
    order: "asc",
  });

  filter.sort = newSort;
};

const SEARCH_INPUT_SELECTOR = "[data-js-search-input], .wizzy-search-input";

// Paste-before-Wizzy-init: remember query; frontend flushes it after bind.
window.__wizzyPendingSearchQuery = window.__wizzyPendingSearchQuery || "";
console.log("before rememberPendingSearchQuery")
function rememberPendingSearchQuery(input) {
  console.log("rememberPendingSearchQuery",input);
  const query = (input && input.value ? input.value : "").trim();
    console.log("query",query);

  if (query) {
    window.__wizzyPendingSearchQuery = query;
  }
}

function activateSearchOverlay(input) {
  if (!input) return;

  document.querySelectorAll(".search-results-overlay").forEach((overlay) => {
    overlay.style.removeProperty("display");
  });

  const overlayId = input.dataset.jsFocusOverlay;
  if (overlayId) {
    document.getElementById(overlayId)?.classList.add("active");
  }
}

function triggerSearchAutocomplete(input) {
  if (!input) return;

  const query = input.value.trim();
  if (!query) return;

  input.dispatchEvent(new Event("input", { bubbles: true }));
  input.dispatchEvent(
    new KeyboardEvent("keyup", { bubbles: true, key: "Unidentified" })
  );
}

function syncSearchInputsWithValue() {
  document.querySelectorAll(SEARCH_INPUT_SELECTOR).forEach((input) => {
    if (input.value.trim()) {
      triggerSearchAutocomplete(input);
    }
  });
}

function handleSearchInputEvent(event) {
  console.log("event",window.__wizzyPendingSearchQuery);
  const input = event.target.closest?.(SEARCH_INPUT_SELECTOR);
  if (!input) return;

  activateSearchOverlay(input);

  if (event.type === "focusin" && input.value.trim()) {
    rememberPendingSearchQuery(input);
    triggerSearchAutocomplete(input);
    return;
  }

  if (event.type === "paste") {
    setTimeout(() => {
      rememberPendingSearchQuery(input);
      triggerSearchAutocomplete(input);
    }, 0);
  }
}

// document.addEventListener("focusin", handleSearchInputEvent, true);
// document.addEventListener("paste", handleSearchInputEvent, true);
// document.addEventListener(
//   "input",
//   function (event) {
//     const input = event.target.closest?.(SEARCH_INPUT_SELECTOR);
//     if (!input) return;

//     if (
//       event.inputType === "insertFromPaste" ||
//       event.inputType === "insertFromDrop"
//     ) {
//       activateSearchOverlay(input);
//       rememberPendingSearchQuery(input);
//       triggerSearchAutocomplete(input);
//     }
//   },
//   true
// );

var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

if (sourceElement) {
  var clonedContent = sourceElement.cloneNode(true);

  var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");

  if (targetDiv && !targetDiv.querySelector(".wizzy-search-sort-wrapper")) {
    targetDiv.appendChild(clonedContent);
  }
}

if (window.innerWidth < 768) {
  var sortInFilter = document.querySelector(
    ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
  );
  if (
    sortInFilter &&
    !sortInFilter.classList.contains("click-listener-attached")
  ) {
    sortInFilter.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var sortOptions = document.querySelector(".wizzy-common-select-options");
      if (sortOptions) {
        if (
          sortOptions.style.display === "none" ||
          sortOptions.style.display === ""
        ) {
          sortOptions.style.display = "grid";
        } else {
          sortOptions.style.display = "none";
        }
      }
    });
    sortInFilter.classList.add("click-listener-attached");
  }
}

if (window.innerWidth < 768) {
  const mobileSearchInput = document.querySelector(
    'input[data-js-focus-overlay="search-results-overlay-mobile"]'
  );

  if (mobileSearchInput) {
    mobileSearchInput.addEventListener("focus", function () {
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
    });

    mobileSearchInput.addEventListener("blur", function () {
      document.body.style.height = "";
      document.body.style.overflow = "";
    });
  }
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      addSortingbestsellers(data.filters);
      // addSorting(data.filters);
      return data; // Return the modified payload
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
        setTimeout(syncAutocompleteWidth, 2);
        return data;
    }
);
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      addSortingforauto(data);
      return data; // Return the modified payload
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      if (data?.sort?.length && data?.sort[0].field == "relevance") {
        data.sort = [
          { field: "product_same_day_shipping_custom", order: "desc" },
          {
            field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
            order: "desc",
          },
          { field: "relevance", order: "asc" },
          { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
        ];
      }
      document.querySelector(".search-results-overlay").click();
      if (window.innerWidth < 768) {
        document.querySelector("#search-results-overlay-mobile").click();
      }

      // document.querySelector(".wizzy-autocomplete-wrapper").style.display =
      //   "none";
      document.querySelector(".search-results-overlay").click();
      addSortingbestsellers(data);
      // addSorting(data);
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      window.__wizzyAcExtraSuggestions =
        collectAutocompleteBrandAndTypeValues(data);
      setTimeout(appendAutocompleteBrandAndTypeSuggestions, 0);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        product.attributes.forEach((attr) => {
          if (attr.id === "product_badge_judgeme") {
            const htmlString = attr.values?.[0]?.value?.[0];
            if (!htmlString) return;

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = htmlString;

            const badge = tempDiv.querySelector(".jdgm-prev-badge");
            if (!badge) return;

            const averageRating = parseFloat(
              badge.getAttribute("data-average-rating") || "0"
            );
            product.avgRatings = averageRating === 0 ? 0 : averageRating;
            product.numberOfReviews = badge.getAttribute(
              "data-number-of-reviews"
            );
            product.starRatingWidth = Math.max(
              0,
              Math.min(100, (product.avgRatings / 5) * 100)
            );
          }
          if (attr.id === "product_same_day_shipping_custom") {
            if (attr.values[0].value[0] == "Yes")
              product.showsamedayshippingtag = true;
          }

           if (attr.id === "product_free_shipping_custom") {
             if (attr.values[0].value[0] == "Yes")
               product.showFreeShippingtag = true;
           }

          if (attr.id === "product_sku") {
            const skuval = attr.values[0].value[0];
            product.skuValue = skuval;
          }
          if (attr.id === "product_vendor") {
            const vendorname = attr.values[0].value[0];
            product.vendorName = vendorname;
          }
        });

        applyProductDiscount(product);
      });
      // // change text of filter button on mobile
      // const filterElement = document.querySelector(
      //   ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-filters-mobile-entry"
      // );

      // if (filterElement) {
      //   filterElement.textContent = "Filter & Sort";
      // } else {
      //   console.warn("Element not found!");
      // }

      return products;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      if (data?.sort?.length && data?.sort[0].field == "relevance") {
        data.sort = [
          { field: "product_same_day_shipping_custom", order: "desc" },
          {
            field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
            order: "desc",
          },
          { field: "relevance", order: "asc" },
          { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
        ];
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {

      if (
        data?.filters?.sort?.length &&
        data?.filters?.sort[0].field == "relevance"
      ) {
        data.filters.sort = [
          { field: "product_same_day_shipping_custom", order: "desc" },
          {
            field: "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
            order: "desc",
          },
          { field: "relevance", order: "asc" },
          { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
        ];
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      baCurr.refreshConversion();
      if (window.innerWidth < 768) {
        window.wizzyConfig.search.configs.general.noOfProducts = 24;
        var header = document.querySelector(".wizzy-filters-header");
        var stickyElement = document.querySelector(
          ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left.wizzy-v2 .wizzy-search-filters-left-wrapper"
        );
        var closeBtn = document.querySelector(
          ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-close-btn"
        );

        if (header && stickyElement) {
          var headerRect = header.getBoundingClientRect();
          stickyElement.style.position = "absolute";

          stickyElement.style.top = headerRect.bottom + "px";
          stickyElement.style.width = "100%";
        }

        if (closeBtn) {
          let screenHeight = window.innerHeight;
          let adjustedTop = (screenHeight / 667) * 104; // Scale proportionally
          closeBtn.style.display = "block";
          closeBtn.style.top = `${adjustedTop}px`;
        }

        var applyAll = document.querySelector(".wizzy-apply-all-button");

        document
          .querySelectorAll(".wizzy-grid-filters-box ul li")
          .forEach((li) => {
            li.addEventListener("click", () => {
              applyAll.click();
            });
          });

        const targetNode = $("body")[0];

        const observer = new MutationObserver(function () {
          if ($("body").hasClass("wizzy-overlay-opened")) {
            $(".widget-visible").each(function () {
              $(this).attr("style", "display: none !important;"); // Force !important for widget-visible
            });

            $(
              ".smile-improved-mobile-launcher, .jdgm-revs-tab-btn.btn, .omnisend-form-67c8d86307be655774af8b45-rectangle-teaser"
            ).hide(); // Regular hide (no !important)
          } else {
            $(".widget-visible").each(function () {
              $(this).removeAttr("style"); // Remove inline style
            });

            $(
              ".smile-improved-mobile-launcher, .jdgm-revs-tab-btn.btn, .omnisend-form-67c8d86307be655774af8b45-rectangle-teaser"
            ).show(); // Show normally
          }
        });

        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
      // addtocart change currency
      const sidebarDrawer = document.querySelector("#site-cart-sidebar");

      if (sidebarDrawer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === "style") {
              const displayStyle =
                window.getComputedStyle(sidebarDrawer).display;
              if (displayStyle === "grid") {
                setTimeout(() => {
                  if (
                    typeof baCurr !== "undefined" &&
                    typeof baCurr.refreshConversion === "function"
                  ) {
                    baCurr.refreshConversion();
                  } else {
                    console.warn(
                      "baCurr.refreshConversion is not defined or not a function"
                    );
                  }
                }, 1000); // Delay in milliseconds (adjust as needed)
              }
            }
          });
        });

        observer.observe(sidebarDrawer, {
          attributes: true,
          attributeFilter: ["style"],
        });
      }

      // autocomplete wrapper change currency
      document.querySelectorAll(".wizzy-search-input").forEach((input) => {
        input.addEventListener("click", function () {
          setTimeout(() => {
            if (
              typeof baCurr !== "undefined" &&
              typeof baCurr.refreshConversion === "function"
            ) {
              baCurr.refreshConversion();
            } else {
              console.warn(
                "baCurr.refreshConversion is not defined or not a function"
              );
            }
          }, 100); // Delay execution by 1 second (adjust if needed)
        });
      });

      if (window.innerWidth < 768) {
        var sourceElement = document.querySelector(
          ".wizzy-search-sort-wrapper"
        );

        if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(true);

          var targetDiv = document.querySelector(
            ".wizzy-sort-wrapper-in-filter"
          );

          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        }

        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
        );
        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            var sortOptions = document.querySelector(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions.style.display === "none" ||
                sortOptions.style.display === ""
              ) {
                sortOptions.style.display = "grid";
              } else {
                sortOptions.style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
      }
      if (window.innerWidth < 768) {
        document.querySelectorAll(".wizzy-facet-head").forEach((facetHead) => {
          facetHead.addEventListener("click", function () {
            let facetBlock = this.closest(".wizzy-filters-facet-block"); // Get parent
            let facetBody = facetBlock.querySelector(".wizzy-facet-body"); // Find body

            if (facetBlock.classList.contains("collapsed")) {
              facetBody.style.display = "none"; // Hide if collapsed
            } else {
              facetBody.style.removeProperty("display"); // Show (uses default CSS)
            }
          });
        });
      }

      let button = document.querySelector(".wizzy-apply-all-button");
      if (button) {
        button.textContent =
          button.textContent.charAt(0).toUpperCase() +
          button.textContent.slice(1).toLowerCase();
      }

      if (window.innerWidth < 768) {
        let a = document.querySelector(".wizzy-filters-mobile-entry");

        if (a) {
          function updateStickyPosition() {
            var header = document.querySelector(".wizzy-filters-header");
            var stickyElement = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left.wizzy-v2 .wizzy-search-filters-left-wrapper"
            );
            var closeBtn = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-close-btn"
            );

            if (header && stickyElement) {
              var headerRect = header.getBoundingClientRect();
              stickyElement.style.position = "absolute";

              stickyElement.style.top = headerRect.bottom + "px";
              stickyElement.style.width = "100%";
            }

            if (closeBtn) {
              let screenHeight = window.innerHeight;
              let adjustedTop = (screenHeight / 667) * 104; // Scale proportionally

              closeBtn.style.top = `${adjustedTop}px`;
            }
          }

          // Click event
          a.addEventListener("click", function () {
            setTimeout(updateStickyPosition, 100);
          });

          // Resize event to adjust positioning dynamically
          window.addEventListener("resize", updateStickyPosition);
        }
      }

      // function updateVisibility() {
      //   let options = document.querySelector(
      //     ".wizzy-common-select-container .wizzy-common-select-options"
      //   );
      //   let container = document.querySelector(
      //     ".wizzy-common-select-container"
      //   );
      //   let selector = document.querySelector(".wizzy-common-select-selector");
      //   let selectedItem = document.querySelector(
      //     ".wizzy-common-select-selectedItem"
      //   );

      //   if (options && container) {
      //     let isGrid = window.getComputedStyle(options).display === "grid";

      //     if (isGrid) {
      //       options.style.top = "53px"; // Set top when display is grid
      //       container.style.overflow = "visible"; // Remove overflow:hidden
      //       if (selector) selector.classList.add("hide-after"); // Hide ::after dynamically
      //       if (selectedItem) selectedItem.style.display = "none";
      //     } else {
      //       options.style.top = ""; // Reset when not grid
      //       container.style.overflow = ""; // Restore original overflow
      //       if (selector) selector.classList.remove("hide-after");
      //       if (selectedItem) selectedItem.style.display = "";
      //     }
      //   }
      // }

      // // Observe for changes in inline styles
      // const observer = new MutationObserver(updateVisibility);
      // const targetNode = document.querySelector(".wizzy-common-select-options");

      // if (targetNode) {
      //   observer.observe(targetNode, {
      //     attributes: true,
      //     attributeFilter: ["style"],
      //   });
      // }

      // updateVisibility();

      var filterPanel = document.querySelectorAll(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block"
      );

      if (window.innerWidth < 768) {
        filterPanel.forEach((facet) => {
          facet.addEventListener("click", function (e) {
            const currentFilter = this; // Get the parent filter element

            const isActive = currentFilter.classList.contains("collapsed");

            // console.log(currentFilter);

            // Close all filters

            setTimeout(() => {
              filterPanel.forEach((h) => {
                const filter = h;

                if (filter !== currentFilter) {
                  filter.classList.add("collapsed");
                }
              });

              if (isActive) {
                currentFilter.classList.remove("collapsed");
              }
              // else {
              //   currentFilter.classList.add("collapsed");
              // }
            }, 100);
          }); 
        });
      }

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // window.wizzyConfig.search.configs.general.behaviour =
      //   "search_as_you_type";
      // window.wizzyConfig.autocomplete.enabled = !1;
      data.search.configs.pagination.infiniteScrollOffset = {
        desktop: 1300,
        mobile: 3000,
      };
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;

      return data;
    }
  );
  syncSearchInputsWithValue();
};
